import { render, staticRenderFns } from "./StudipDate.vue?vue&type=template&id=3033e5a8&"
import script from "./StudipDate.vue?vue&type=script&lang=js&"
export * from "./StudipDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports